import { useEffect } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import {
  useActivateProjectMutation,
  useDeactivateProjectMutation,
  useGetProjectByIdQuery,
} from 'src/services';
import { useParams } from 'react-router-dom';
import { Button } from 'src/components/ui/button';

export const ProjectActivateContent = ({ onlyForm = false, close = () => {} }) => {
  const notification = useNotification();
  const { id } = useParams();

  const { data: currentProject } = useGetProjectByIdQuery({ id: id });

  const isActive = currentProject?.is_active;

  const [activateProject, { isLoading, isSuccess }] = useActivateProjectMutation();

  const [deactivateProject, { isLoading: deactivateProjectIsLoading }] =
    useDeactivateProjectMutation();

  useEffect(() => {
    if (isSuccess) {
      close();
      notification.success('Project has been activated!');
    }
  }, [isSuccess]);

  const projectActivateHandler = () => {
    if (isActive) {
      deactivateProject({ projectId: id }).then((deactivateProjectResult) => {
        if (!('error' in deactivateProjectResult)) {
          close();
          notification.success('Project has been deactivated!');
        }
      });
    } else {
      activateProject({ projectId: id });
    }
  };

  const actionLabel = isActive ? 'Deactivate' : 'Activate';

  return (
    <>
      <div className="content">
        <div className="sub-title flex flex-col gap-1.5">
          <h4>Are you sure you want to {isActive ? 'deactivate' : 'activate'} this project?.</h4>
        </div>
      </div>
      <div className="footer flex justify-end mt-5">
        <div className="help-container"></div>
        <div className="action-buttons flex gap-2.5">
          {!onlyForm && (
            <Button
              variant="pill-outline-dark"
              size="pill"
              className="min-w-28"
              onClick={() => close()}
            >
              Cancel
            </Button>
          )}
          <Button
            variant="pill-blue"
            size="pill"
            onClick={projectActivateHandler}
            disabled={isLoading || deactivateProjectIsLoading}
            className="min-w-28"
          >
            {isLoading || deactivateProjectIsLoading ? 'Loading...' : actionLabel}
          </Button>
        </div>
      </div>
    </>
  );
};
